import type { AdditionalServiceType } from 'graphql-ts-types';

import { EventBusEvent } from 'common/enums/EventBus';
import { useSubscription } from 'common/hooks/subscription';

export const useSelectedServices = (isDisabled = false) => {
  const [services] = useSubscription<AdditionalServiceType[]>(
    EventBusEvent.AdditionalServicesUpdate,
    {
      isDisabled,
    }
  );

  return services;
};
